import React from 'react';

import classes from './InfoLayoverTag.scss';

const InfoLayoverTag = (props) => (
    <span className={[classes.BackgroundBox, 'u-phoneHide' , 
        props.type === 1 ? classes.BackgroundBoxOne : 
        props.type === 2 ? classes.BackgroundBoxTwo : 
        props.type === 3 ? classes.BackgroundBoxThree : null].join(' ')}>{props.children}</span>
);

export default InfoLayoverTag;


// WEBPACK FOOTER //
// ./src/components/Flight/Tuple/TupleInner/FlightInfo/FlightInfoLayover/InfoLayoverTag/InfoLayoverTag.js